<template>
  <div class="personalInfo_page">
    <div class="title_box flex_center">
      <img src="./image/order_icon3.png" class="order_icon" />
      <div class="flex_column">
        <div class="order_title">会员信息</div>
        <div class="order_subtitle">
          完善会员信息, 以便我们为您提供更好的服务!
          下单平台不会以任何形式公开您的个人隐私, 请放心填写!
        </div>
      </div>
    </div>
    <div class="content_box">
      <el-descriptions title="会员信息" :column="2" border class="descriptions">
        <el-descriptions-item label="会员号">{{
          personalInfo.companyName
        }}</el-descriptions-item>
        <el-descriptions-item label="公司名称">{{
          personalInfo.companyName
        }}</el-descriptions-item>
        <el-descriptions-item label="联系人">{{
          personalInfo.companyContact
        }}</el-descriptions-item>
        <el-descriptions-item label="联系手机">{{
          personalInfo.phone
        }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{
          personalInfo.telephone
        }}</el-descriptions-item>
        <el-descriptions-item label="邮箱">{{
          personalInfo.email
        }}</el-descriptions-item>
        <el-descriptions-item label="QQ">{{
          personalInfo.qq
        }}</el-descriptions-item>
        <el-descriptions-item label="公司地址">{{
          personalInfo.address
        }}</el-descriptions-item>
        <el-descriptions-item label="所在地"
          >{{ personalInfo.province }}{{ personalInfo.city
          }}{{ personalInfo.area }}</el-descriptions-item
        >
      </el-descriptions>
      <div class="content_flex">
        <div class="content_item">
          <el-descriptions
            title="实名认证"
            class="descriptions"
          ></el-descriptions>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="150px"
            class="demo-ruleForm"
            label-position="top"
          >
            <el-form-item label="认证类型" prop="certificationType">
              <el-radio-group
                v-model="personalInfo.certificationType"
                :disabled="
                  (personalInfo.certificationStatus === null || personalInfo.certificationStatus === 'FAIL') ? false : true
                "
              >
                <el-radio label="PERSONAL">个人认证</el-radio>
                <el-radio label="COMPANY">企业认证</el-radio>
              </el-radio-group>
              <span v-if="personalInfo.certificationStatus !== null" class="ml12">
                认证状态：{{  $enums.certificationStatusEnum.getLabelByValue(personalInfo.certificationStatus) }}
              </span>
            </el-form-item>
            <template v-if="personalInfo.certificationType === 'PERSONAL'">
              <el-form-item label="个人认证姓名" prop="certificationPersonName">
                <el-input
                  v-model="personalInfo.certificationPersonName"
                  class="width200"
                  :disabled="
                    (personalInfo.certificationStatus === null || personalInfo.certificationStatus === 'FAIL') ? false : true
                  "
                ></el-input>
              </el-form-item>
              <el-form-item label="个人认证身份证号" prop="certificationIdCard">
                <el-input
                  v-model="personalInfo.certificationIdCard"
                  class="width200"
                  :disabled="
                    (personalInfo.certificationStatus === null || personalInfo.certificationStatus === 'FAIL') ? false : true
                  "
                ></el-input>
              </el-form-item>
              <el-form-item
                label="个人认证身份证"
                prop="certificationPersonIdCardFront"
              >
                <div class="flex">
                  <div class="mr12">
                    <el-image
                      class="img"
                      style="width: 200px; height: 130px"
                      :src="personalInfo.certificationPersonIdCardFront"
                      :preview-src-list="[
                        personalInfo.certificationPersonIdCardFront,
                      ]"
                      v-if="personalInfo.certificationPersonIdCardFront"
                    >
                    </el-image>
                    <div class="small_upload_box" v-if="personalInfo.certificationStatus === null || personalInfo.certificationStatus === 'FAIL'">
                      <input
                        type="file"
                        accept="image/"
                        @change="
                          handleUpdataFile(
                            $event,
                            'certificationPersonIdCardFront'
                          )
                        "
                      />
                      <i class="el-icon-box upload_icon"></i>
                      <span class="bold">上传身份证正面</span>

                      <span style="line-height: 15px"
                        >支持jpg/png/gif格式的图片,不大于10M。支持MP4格式视频,不大于10M。</span
                      >
                    </div>
                  </div>
                  <div>
                    <el-image
                      class="img"
                      style="width: 200px; height: 130px"
                      :src="personalInfo.certificationPersonIdCardBack"
                      :preview-src-list="[
                        personalInfo.certificationPersonIdCardBack,
                      ]"
                      v-if="personalInfo.certificationPersonIdCardBack"
                    >
                    </el-image>
                    <div class="small_upload_box" v-if="personalInfo.certificationStatus === null || personalInfo.certificationStatus === 'FAIL'">
                      <input
                        type="file"
                        accept="image/"
                        @change="
                          handleUpdataFile(
                            $event,
                            'certificationPersonIdCardBack'
                          )
                        "
                      />
                      <i class="el-icon-box upload_icon"></i>
                      <span class="bold">上传身份证反面</span>

                      <span style="line-height: 15px"
                        >支持jpg/png/gif格式的图片,不大于10M。支持MP4格式视频,不大于10M。</span
                      >
                    </div>
                  </div>
                </div>
              </el-form-item>
            </template>
            <template v-if="personalInfo.certificationType === 'COMPANY'">
              <el-form-item label="公司名称" prop="certificationCompanyName">
                <el-input
                  v-model="personalInfo.certificationCompanyName"
                  class="width200"
                  :disabled="
                    (personalInfo.certificationStatus === null || personalInfo.certificationStatus === 'FAIL') ? false : true
                  "
                ></el-input>
              </el-form-item>
              <el-form-item
                label="社会信用统一代码"
                prop="certificationCompanyCode"
              >
                <el-input
                  v-model="personalInfo.certificationCompanyCode"
                  class="width200"
                  :disabled="
                    (personalInfo.certificationStatus === null || personalInfo.certificationStatus === 'FAIL') ? false : true
                  "
                ></el-input>
              </el-form-item>
              <el-form-item label="营业执照" prop="certificationCompanyLicense">
                <el-image
                  class="img"
                  :src="personalInfo.certificationCompanyLicense"
                  :preview-src-list="[personalInfo.certificationCompanyLicense]"
                  v-if="personalInfo.certificationCompanyLicense"
                >
                </el-image>
                <div class="small_upload_box"  v-if="personalInfo.certificationStatus === null || personalInfo.certificationStatus === 'FAIL'">
                  <input
                    type="file"
                    accept="image/"
                    @change="
                      handleUpdataFile($event, 'certificationCompanyLicense')
                    "
                  />
                  <i class="el-icon-box upload_icon"></i>
                  <span class="bold">点击或拖拽文件至此处上传</span>

                  <span style="line-height: 15px"
                    >支持jpg/png/gif格式的图片,不大于10M。支持MP4格式视频,不大于10M。</span
                  >
                </div>
              </el-form-item>
            </template>

            <el-form-item
              label=""
              v-if="(personalInfo.certificationStatus === null || personalInfo.certificationStatus === 'FAIL')"
            >
              <el-button type="primary" @click="toAuthentication">
                认证
              </el-button>
            </el-form-item>
          </el-form>
        </div>
        <div
          class="content_item"
          v-if="personalInfo.certificationType === 'COMPANY'"
        >
          <el-descriptions
            title="发票信息"
            class="descriptions"
          ></el-descriptions>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="150px"
            class="demo-ruleForm"
            label-position="top"
          >
            <!-- <el-form-item label="发票抬头" prop="certificationCompanyName">
              <el-input
                v-model="personalInfo.certificationCompanyName"
              ></el-input>
            </el-form-item> -->
            <el-form-item
              label="社会统一信用代码"
              prop="certificationCompanyCode"
            >
              <el-input
                v-model="personalInfo.certificationCompanyCode"
                :disabled="
                  (personalInfo.certificationStatus === null || personalInfo.certificationStatus === 'FAIL') ? false : true
                "
              ></el-input>
            </el-form-item>
            <el-form-item label="开户银行" prop="bankName">
              <el-input
                v-model="personalInfo.bankName"
                :disabled="
                  (personalInfo.certificationStatus === null || personalInfo.certificationStatus === 'FAIL') ? false : true
                "
              ></el-input>
            </el-form-item>
            <el-form-item label="银行账号" prop="bankCard">
              <el-input
                v-model="personalInfo.bankCard"
                :disabled="
                  (personalInfo.certificationStatus === null || personalInfo.certificationStatus === 'FAIL') ? false : true
                "
              ></el-input>
            </el-form-item>
            <el-form-item label="注册地址" prop="companyAddress">
              <el-input
                v-model="personalInfo.companyAddress"
                :disabled="
                  (personalInfo.certificationStatus === null || personalInfo.certificationStatus === 'FAIL') ? false : true
                "
              ></el-input>
            </el-form-item>
            <el-form-item label="电话号码" prop="bankPhone">
              <el-input
                v-model="personalInfo.bankPhone"
                :disabled="
                  (personalInfo.certificationStatus === null || personalInfo.certificationStatus === 'FAIL') ? false : true
                "
              ></el-input>
            </el-form-item>
            <el-form-item label="开票类型" prop="billingType">
              <el-radio-group
                v-model="personalInfo.billingType"
                :disabled="
                  (personalInfo.certificationStatus === null || personalInfo.certificationStatus === 'FAIL') ? false : true
                "
              >
                <el-radio label="GENERAL">普票</el-radio>
                <el-radio label="SPECIAL">专票</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  personalInfoApi,
  personalInfoUnloadApi,
  getOssAuth,
} from "../../api/index";
export default {
  name: "personalInfo",
  data() {
    return {
      ruleForm: {
        radio: 3,
        name: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
      },
      url: "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
      srcList: [
        "https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg",
        "https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg",
      ],
      personalInfo: {
        userId: 1,
        companyName: "",
        companyContact: "",
        phone: "",
        telephone: "",
        qq: "",
        email: "",
        province: "",
        city: "",
        area: "",
        address: "",
        certificationType: "PERSONAL",
        certificationCompanyName: "",
        certificationCompanyCode: "",
        certificationCompanyLicense: "",
        certificationPersonName: "",
        certificationIdCard: "",
        certificationPersonIdCardFront: "",
        certificationPersonIdCardBack: "",
        certificationStatus: "",
        bankName: "",
        bankCard: "",
        companyAddress: "",
        bankPhone: "",
        billingType: "",
      },
    };
  },
  created() {},
  activated() {
    this.getInfo();
  },
  mounted() {
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    getInfo() {
      personalInfoApi()
        .then((res) => {
          if (res.resultStatus) {
            this.personalInfo = { ...res.resultData };
          } else {
            this.personalInfo = {
              userId: 1,
              companyName: "",
              companyContact: "",
              phone: "",
              telephone: "",
              qq: "",
              email: "",
              province: "",
              city: "",
              area: "",
              address: "",
              certificationType: "",
              certificationCompanyName: "",
              certificationCompanyCode: "",
              certificationCompanyLicense: "",
              certificationPersonName: "",
              certificationIdCard: "",
              certificationPersonIdCardFront: "",
              certificationPersonIdCardBack: "",
              certificationStatus: "",
              bankName: "",
              bankCard: "",
              companyAddress: "",
              bankPhone: "",
              billingType: "",
            };
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    // 上传文件
    handleUpdataFile(e, type) {
      if (e.target.files.length) {
        const file = e.target.files[0];
        if (file) {
          const form = new FormData();
          form.append("file", file);
          getOssAuth(form).then((res) => {
            if (res.resultStatus) {
              if (type === "certificationPersonIdCardFront") {
                this.personalInfo.certificationPersonIdCardFront =
                  res.resultData.fileLink;
              } else if (type === "certificationPersonIdCardBack") {
                this.personalInfo.certificationPersonIdCardBack =
                  res.resultData.fileLink;
              } else if (type === "certificationCompanyLicense") {
                this.personalInfo.certificationCompanyLicense =
                  res.resultData.fileLink;
              }
            }
          });
        }
      }
    },
    toAuthentication() {
      if (this.personalInfo.certificationType === "PERSONAL") {
        if (!this.personalInfo.certificationPersonName) {
          this.$message.warning("请输入个人认证姓名");
          return;
        }
        if (!this.personalInfo.certificationIdCard) {
          this.$message.warning("请输入个人认证身份证号");
          return;
        }
        if (!this.personalInfo.certificationPersonIdCardFront) {
          this.$message.warning("请上传个人认证身份证正面");
          return;
        }
        if (!this.personalInfo.certificationPersonIdCardBack) {
          this.$message.warning("请上传个人认证身份证正面");
          return;
        }
      } else if (this.personalInfo.certificationType === "COMPANY") {
        if (!this.personalInfo.companyName) {
          this.$message.warning("请输入公司名称");
          return;
        }
        if (!this.personalInfo.certificationCompanyLicense) {
          this.$message.warning("请输入社会信用统一代码");
          return;
        }
        if (!this.personalInfo.certificationPersonIdCardFront) {
          this.$message.warning("请上传营业执照");
          return;
        }
        if (!this.personalInfo.bankName) {
          this.$message.warning("请输入开户银行");
          return;
        }
        if (!this.personalInfo.bankCard) {
          this.$message.warning("请输入银行账号");
          return;
        }
        if (!this.personalInfo.bankPhone) {
          this.$message.warning("请输入电话号码");
          return;
        }
        if (!this.personalInfo.billingType) {
          this.$message.warning("请选择开票类型");
          return;
        }
      }

      personalInfoUnloadApi({
        certificationType: this.personalInfo.certificationType,
        certificationCompanyName: this.personalInfo.certificationCompanyName,
        certificationCompanyCode: this.personalInfo.certificationCompanyCode,
        certificationCompanyLicense:
          this.personalInfo.certificationCompanyLicense,
        certificationPersonName: this.personalInfo.certificationPersonName,
        certificationIdCard: this.personalInfo.certificationIdCard,
        certificationPersonIdCardFront:
          this.personalInfo.certificationPersonIdCardFront,
        certificationPersonIdCardBack:
          this.personalInfo.certificationPersonIdCardBack,
        bankName: this.personalInfo.bankName,
        bankCard: this.personalInfo.bankCard,
        companyAddress: this.personalInfo.companyAddress,
        bankPhone: this.personalInfo.bankPhone,
        billingType: this.personalInfo.billingType,
      }).then((res) => {
        if (res.resultStatus) {
          this.$message.success("认证信息已提交,请稍候");
        } else {
          this.$message.warning(res.errorMessage);
        }
      })
      .finally(()=>{
        this.getInfo();
      })
    },
  },
};
</script>

<style lang="less">
.personalInfo_page {
  width: 100%;
  min-height: 100%;
  border: 1px solid #e1e1e1;
  padding: 20px;
  box-sizing: border-box;
  .title_box {
    margin-bottom: 12px;
  }
  .width200 {
    width: 200px;
  }
  .width150 {
    width: 150px;
  }
  .content_box {
    width: 100%;
    box-sizing: border-box;
    .descriptions {
      margin-top: 20px;
    }
  }
  @media screen and (min-width: 480px) {
    .img {
      width: 400px;
      height: 600px;
    }
    .content_flex {
      display: flex;
      .content_item {
        width: 50%;
      }
    }
  }
  @media only screen and (max-width: 480px) {
    .img {
      width: 200px;
      height: 200px;
    }
    .content_flex {
      display: flex;
      flex-direction: column;
      .content_item {
        width: 100%;
      }
    }
  }
}
.el-tabs__item {
  color: #999;
}
.el-tabs__item:hover {
  color: #00a0e9;
}
.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border: 1px solid #2f4050;
  border-bottom: 0;
}
.el-tabs__item.is-active {
  color: #000000;
}
</style>